var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 11.1672C7.87202 11.1672 7.744 11.1185 7.64666 11.0205L2.98 6.35386C2.78466 6.15852 2.78466 5.84183 2.98 5.6465C3.17533 5.45117 3.49202 5.45117 3.68735 5.6465L8.00067 9.95981L12.314 5.6465C12.5093 5.45117 12.826 5.45117 13.0213 5.6465C13.2167 5.84183 13.2167 6.15852 13.0213 6.35386L8.35467 11.0205C8.256 11.1185 8.12802 11.1672 8.00002 11.1672Z",
    fill: "#F4F5F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.19d982529848a963e41f378602c35bd3.svg";
export { ForwardRef as ReactComponent };